import React from 'react';

import { Heading, Projects } from '../../../components';



const ProjectSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Projects'} subTitle={'Community Initiatives'} />

      {/* Project Section */}
      <Projects />

    </section>

  );
}

export default ProjectSection;